import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { storeUtils } from "./util";

const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = "change";
var _outageState = {};
var _outageList = [];
var _loadingOutageList = false;

var dispatchToken = dispatcher.register(function (action) {
  //this action comes from the dispatcher
  switch (action.type) {
    case ActionTypes.OUTAGE_FROM_SERVER:
      _loadingOutageList = false;
      _outageState = action.outageState;
      console.log("New outage state", _outageState);
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.LOAD_OUTAGE_LIST:
      _outageList = [];
      _loadingOutageList = true;
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.SET_OUTAGE_LIST:
      _outageList = action.list || [];
      _loadingOutageList = false;
      _events.trigger(CHANGE_EVENT);
      break;

    default:
    //no op
  }
}); //end of dispatch token

//public api
export const outageStore = {
  dispatchToken,
  subscribe: _events.on,
  unsubscribe: _events.off,
  isShowingBanner: function () {
    return _outageState && _outageState.isShowingBanner;
  },
  isShowingOutage: function () {
    return _outageState && _outageState.isShowingOutage;
  },
  getCurrentOutage: function () {
    return _outageState && _outageState.outage;
  },
  getOutageList: () => _outageList || [],
  isLoadingOutageList: () => _loadingOutageList,
};
